import React, { useEffect, useRef, useState } from "react";
import SearchForm from "./SearchForm";

// stat icons
const downArrow = `${EASYCOMMERCE.assets}admin/img/icons/select-arrow-down.png`;

const SearchProduct = ({ productName, handleProductSelect }) => {
    const selectRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [products, setProducts] = useState([]);
    const [productSearched, setProductSearched] = useState(false);

    const searchProducts = (e) => {
        setSearchTerm(e.target.value);

        if (e.target.value.length < 3) {
            setProductSearched(false);
            setProducts([]);
            return;
        }

        fetch(
            `${EASYCOMMERCE.rest_base}/products?s=${e.target.value}&status=any`,{
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": EASYCOMMERCE.nonce,
                }
            }
        )
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                setProductSearched(true);
                if (data.success && data.data?.products) {
                    setProducts(data.data.products);
                } else {
                    setProducts([]);
                }
            })
            .catch((error) => {
                setProductSearched(true);
                setProducts([]);
            });
    };

    // Effect to handle clicks outside of the select box
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                selectRef.current &&
                !selectRef.current.contains(event.target)
            ) {
                setIsOpen(false);
                setSearchTerm("");
                setProducts([]);
                setProductSearched(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const productNameWord = productName.split(" ");

    return (
        <div ref={selectRef}>
            <div
                className="easycommerce-select-box relative border bg-white border-[#e3e3e3] 
                rounded-lg w-[200px] cursor-pointer hover:border-ec-secondary transition-all ease-in-out duration-300"
                style={{
                    border: isOpen ? "1px solid var(--color-ec-secondary)" : "",
                    boxShadow: isOpen
                        ? "0px 2px 4.5px 0px var(--color-ec-tertiary)"
                        : "",
                }}
            >
                <span
                    onClick={() => setIsOpen(!isOpen)}
                    className="flex items-center justify-between py-2 px-[15px] h-ec-input"
                >
                    <p
                        className={`text-ec-body text-base font-inter leading-[26px]`}
                        title={productName}
                    >
                        {productNameWord.length > 4
                            ? `${productNameWord.slice(0, 4).join(" ")} ...`
                            : productName || "All Products"}
                    </p>
                    <img
                        src={downArrow}
                        className="w-3 h-auto pointer-events-none"
                    />
                </span>

                {isOpen && (
                    <SearchForm
                        products={products}
                        searchTerm={searchTerm}
                        productSearched={productSearched}
                        handleProductSelect={handleProductSelect}
                        searchProducts={searchProducts}
                    />
                )}
            </div>
        </div>
    );
};

export default SearchProduct;
